import { forwardRef, type SVGProps } from 'react';

export type ThumbUpIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const ThumbUpIcon = forwardRef<SVGSVGElement, ThumbUpIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <g clipPath="url(#a)">
      <path
        d="M4.66667 7.33335V12.6667C4.66667 12.8435 4.59643 13.0131 4.4714 13.1381C4.34638 13.2631 4.17681 13.3334 4 13.3334H2.66667C2.48986 13.3334 2.32029 13.2631 2.19526 13.1381C2.07024 13.0131 2 12.8435 2 12.6667V8.00002C2 7.82321 2.07024 7.65364 2.19526 7.52862C2.32029 7.40359 2.48986 7.33335 2.66667 7.33335H4.66667ZM4.66667 7.33335C5.37391 7.33335 6.05219 7.0524 6.55228 6.5523C7.05238 6.05221 7.33333 5.37393 7.33333 4.66669V4.00002C7.33333 3.6464 7.47381 3.30726 7.72386 3.05721C7.97391 2.80716 8.31304 2.66669 8.66667 2.66669C9.02029 2.66669 9.35943 2.80716 9.60948 3.05721C9.85952 3.30726 10 3.6464 10 4.00002V7.33335H12C12.3536 7.33335 12.6928 7.47383 12.9428 7.72388C13.1929 7.97393 13.3333 8.31306 13.3333 8.66669L12.6667 12C12.5708 12.409 12.3889 12.7602 12.1484 13.0007C11.908 13.2411 11.6219 13.3579 11.3333 13.3334H6.66667C6.13623 13.3334 5.62753 13.1226 5.25245 12.7476C4.87738 12.3725 4.66667 11.8638 4.66667 11.3334"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </g>
    <defs>
      <clipPath id="a">
        <rect fill="currentColor" height="16" width="16" />
      </clipPath>
    </defs>
  </svg>
));

ThumbUpIcon.displayName = 'ThumbUpIcon';
